export enum ApplicationPermissions {
  uwSSOConfigurationSetup = 'uwSSOConfigurationSetUp',
  unitedWayAdmin  = 'unitedWayAdmin',
  reportCCCReport = 'reportCCCReport',
  reportAdmin  = 'reportAdmin',
  canvasserAdmin = 'canvasserAdmin',
  caEmail = "caEmail",
  canSeeReportDollars = "canSeeReportDollars",
  canSeeReportEmployeeNumber = "canSeeReportEmployeeNumber",
  canSeeReportOptOut = "canSeeReportOptOut",
  reportAdHoc = "reportAdHoc",
  reportAllCanvassers = "reportAllCanvassers",
  reportCampaignHierarchy = "reportCampaignHierarchy",
  reportCanvasser = "reportCanvasser",
  reportCashChequeCreditCardPaidUA = "reportCashChequeCreditCardPaidUA",
  reportCashChequeCreditCardReceivedWA = "reportCashChequeCreditCardReceivedWA",
  reportCharityAllocationSummary = "reportCharityAllocationSummary",
  reportCompanyCampaignExtractedAndUnExtracted = "reportCompanyCampaignExtractedAndUnExtracted",
  reportCompanyCampaignExtractedReconciliation = "reportCompanyCampaignExtractedReconciliation",
  reportCompanyCampaignHierarchy = "reportCompanyCampaignHierarchy",
  reportCompanyCampaignUnpaid = "reportCompanyCampaignUnpaid",
  reportCompanyCampaignWorkplace = "reportCompanyCampaignWorkplace",
  reportCompanyLevelPayrollDeductions = "reportCompanyLevelPayrollDeductions",
  reportCorpAllCanvassers = "reportCorpAllCanvassers",
  reportCorpCampaignHierarchy = "reportCorpCampaignHierarchy",
  reportCorpEmployeeStatus = "reportCorpEmployeeStatus",
  reportDailyStatus = "reportDailyStatus",
  reportDecidedUnDecidedFinancial = "reportDecidedUnDecidedFinancial",
  reportDecidedUnDecidedNonFinancial = "reportDecidedUnDecidedNonFinancial",
  reportEditAdHoc = "reportEditAdHoc",
  reportEmployeeStatus = "reportEmployeeStatus",
  reportEmployeeTransaction = "reportEmployeeTransaction",
  reportFairShare_Co = "reportFairShare_Co",
  reportFairShare_Internal = "reportFairShare_Internal",
  reportLeadershipStatus = "reportLeadershipStatus",
  reportLeadershipSummary = "reportLeadershipSummary",
  reportLocalResults = "reportLocalResults",
  reportLocalUWResults = "reportLocalUWResults",
  reportLocalUWResultsReportNationalCampaigns = "reportLocalUWResultsReportNationalCampaigns",
  reportLocalUWResultsReportNationalCampaigns_FR = "reportLocalUWResultsReportNationalCampaigns_FR",
  reportOverallStatus = "reportOverallStatus",
  reportPaymentGatewayRecDetail = "reportPaymentGatewayRecDetail",
  reportPaymentGatewayRecSum = "reportPaymentGatewayRecSum",
  reportPayrollDeductions = "reportPayrollDeductions",
  reportKioskSummary = "reportKioskSummary",
  reportSurveyQuestion = "reportSurveyQuestion",
  reportSweepstakes = "reportSweepstakes",
  reportUpsellStatus = "reportUpsellStatus",
  setTempPassword = "setTempPassword",
  uwAllCampaigns = "uwAllCampaigns",
  uwCampaignCreate = "uwCampaignCreate",
  uwCampaignProfile = "uwCampaignProfile",
  uwCanEditAllDonations = "uwCanEditAllDonations",
  uwCompanyCampaignCreate = "uwCompanyCampaignCreate",
  uwCompanyCampaignSetup = "uwCompanyCampaignSetup",
  uwConvertToAPR = "uwConvertToAPR",
  uwDeleteEditOneTimeDonations = "uwDeleteEditOneTimeDonations",
  uwDonorServices = "uwDonorServices",
  uwExternalDataEntry = "uwExternalDataEntry",
  uwGenerateAPR = "uwGenerateAPR",
  uwPaidChecklists = "uwPaidChecklists",
  uwReceivedChecklists = "uwReceivedChecklists",
  uwReporting = "uwReporting",
  uwResendTaxReceipt = "uwResendTaxReceipt",
  uwResetDonation = "uwResetDonation",
  uwUploadExtract = "uwUploadExtract",
  uwUserSetup = "uwUserSetup",
  uwUtilities = "uwUtilities",
  uwWebPageManagement = "uwWebPageManagement",
  uwWebPartManagement = "uwWebPartManagement",
  waWebPageManagement = "waWebPageManagement",
  waWebPartManagement = "waWebPartManagement",
  wrkPlAllCampaignGroups = "wrkPlAllCampaignGroups",
  wrkPlCampaignDashboardOnly = "wrkPlCampaignDashboardOnly",
  wrkPlCampaignSetup = "wrkPlCampaignSetup",
  wrkPlCompanyLevel = "wrkPlCompanyLevel",
  wrkPlDataEntry = "wrkPlDataEntry",
  wrkPlEmail = "wrkPlEmail",
  wrkPlEmployeeGroupMgmt = "wrkPlEmployeeGroupMgmt",
  wrkPlFairShareAssignment = "wrkPlFairShareAssignment",
  wrkPlReporting = "wrkPlReporting",
  wrkPlUserSetup = "wrkPlUserSetup",
  uwUserLoginMoniotor = "uwUserLoginMoniotor",
  uwPrivateCampaign = "uwPrivateCampaign"
}
